var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "heart 1",
    clipPath: "url(#clip0_147_2751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_147_2751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1290",
    d: "M0 1.90735e-06H22V22H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_147_2751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1296",
    d: "M10.998 6.70313C10.998 6.70313 12.2356 2.40625 16.1543 2.40625C19.2068 2.40625 21.1387 4.86974 21.1387 7.78817C21.1387 11.8244 17.114 14.4971 10.998 19.5938C4.88209 14.4971 0.857422 11.8244 0.857422 7.78817C0.857422 4.86974 2.7893 2.40625 5.8418 2.40625C9.76055 2.40625 10.998 6.70313 10.998 6.70313Z",
    fill: "#FF6161",
    stroke: "#FF6161",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_2751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.98e66f5d65b6d8b01ea4a037860067fa.svg";
export { ForwardRef as ReactComponent };